<template>
  <!--
      作者：gh
      时间：2025-12-12
      描述：会员-用户列表-会员编辑
  -->
  <div>


    <el-dialog title="会员编辑" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-form size="small" :model="form">
        <el-form-item label="昵称" :label-width="formLabelWidth">
          <el-input v-model="form.nickName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="真实姓名" :label-width="formLabelWidth">
          <el-input v-model="form.username" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" :label-width="formLabelWidth">
          <el-input v-model="form.usernum" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" :label-width="formLabelWidth">
          <el-input v-model="form.email" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="紧急联系人" :label-width="formLabelWidth">
          <el-input v-model="form.jinji" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="紧急联系人电话" :label-width="formLabelWidth">
          <el-input v-model="form.jinjiphone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号" :label-width="formLabelWidth">
          <el-input v-model="form.mobile" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="代理商分佣比例" :label-width="formLabelWidth">
          <el-input v-model="form.proportion_of_agents" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="上传头像" :rules="[{ required: true, message: '请选择头像图片' }]">
          <el-button @click="chooseImg('image','avatarUrl')">选择图片</el-button>
          <img class="mt10" v-img-url="form.avatarUrl" width="200">
        </el-form-item>

        <el-form-item label="上传身份证正面" :rules="[{ required: true, message: '请选择身份证正面图片' }]">
          <el-button @click="chooseImg('image','sfzpositive')">选择图片</el-button>
          <img class="mt10" v-img-url="form.sfzpositive" width="200">
        </el-form-item>

        <el-form-item label="上传身份证反面" :rules="[{ required: true, message: '请选择身份证反面图片' }]">
          <el-button @click="chooseImg('image','sfzback')">选择图片</el-button>
          <img class="mt10" v-img-url="form.sfzback" width="200">
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button type="primary" @click="editUser" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
    <!--上传图片-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" :config="{ total: 1,file_type: 'image' }" @returnImgs="returnImgsFunc"></Upload>
  </div>
</template>

<script>
import UserApi from '@/api/user.js';
import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';
export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      loading: false,
      dialogVisible: false,
      type: [],
      type1: [],
      type2: [],
      /*是否打开图片选择*/
      isupload: false,
    };
  },
  props: ['open_edit1', 'form', 'gradeList'],
  created() {
    this.dialogVisible = this.open_edit1;
    console.log("id", this.form.user_id);
  },
  methods: {
    /*选择图片*/
    chooseImg: function(file_type, file_name) {
      this.file_name = file_name;
      this.isupload = true;
    },

    /*关闭选择图片*/
    returnImgsFunc(e) {
      this.isupload = false;
      if (e != null) {
        if (this.file_name == 'avatarUrl') {
          this.form.avatarUrl = e[0].file_path;
        }else if(this.file_name == 'sfzpositive'){
          this.form.sfzpositive = e[0].file_path;
        }else if(this.file_name == 'sfzback'){
          this.form.sfzback = e[0].file_path;
        }
      }
    },
    returnImgsFunc1(e) {
      this.isupload1 = false;
      if (e != null && e.length > 0) {
        if (this.type == 'image') {
          this.form.sfzpositive = e[0].file_path;
        }
      }
    },
    returnImgsFunc2(e) {
      this.isupload2 = false;
      if (e != null && e.length > 0) {
        if (this.type == 'image') {
          this.form.sfzback = e[0].file_path;
        }
      }
    },
    /*修改用户*/
    editUser() {
      let self = this;
      self.loading = true;
      let params = self.form;
      let newparams = {};
      
      newparams.nickName = params.nickName;
      newparams.username = params.username;
      newparams.usernum = params.usernum;
      newparams.email = params.email;
      newparams.jinji = params.jinji;
      newparams.jinjiphone = params.jinjiphone;
      newparams.mobile = params.mobile;
      newparams.proportion_of_agents = params.proportion_of_agents;
      newparams.avatarUrl = params.avatarUrl;
      newparams.sfzpositive = params.sfzpositive;
      newparams.sfzback = params.sfzback;

      let id = self.form.user_id;
      newparams.user_id = id;
      UserApi.edituser1(newparams, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，用户修改成功',
              type: 'success'
            });
            self.dialogFormVisible(true);
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        })
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        })
      }
    }

  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/user/user/dialog/Useredit.vue